import { COLORS } from './constants';

export const getColor = (i: number) => (COLORS[i] ? COLORS[i] : COLORS[i % COLORS.length]);
